import { createSlice } from '@reduxjs/toolkit';

const messageSlice = createSlice({
  name: 'infoMessage',
  initialState: {
    message: '',  // 메시지 내용
    type: 'info', // 메시지 유형 ('error', 'success' 등)
  },
  reducers: {
    setMessage: (state, action) => {
      state.message = action.payload.message;
      state.type = action.payload.type || 'info';
    },
    clearMessage: (state) => {
      state.message = '';
      state.type = 'info';
    },
  },
});

export const { setMessage, clearMessage } = messageSlice.actions;
export default messageSlice.reducer;
